// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oGAvI","footer":"styles_footer__uuwC-","passCodeTooltip":"styles_passCodeTooltip__3Cqr-"};